<!-- 模板2-单行两个 -->
<template>
  <div
    v-show="options.show"
    class='web_template_wrap'
  >
    <!-- 背景图 -->
    <div
      class="web_template_bgimg"
      v-show="options.options.style.bgType === 'image'"
    >
      <!-- <img v-lazy="options.bgImg"> -->
      <img :src="options.options.style.bgImg">
    </div>
    <!-- 图标内容 -->
    <div
      class="web_template_content"
      :style="{
        backgroundColor: `${
          options.options.style.bgType === 'color'
            ? options.options.style.bgColor
            : ''
        }`,
        paddingBottom: `${ 18 + (isBottomBtn ? 40 : 0) + (isBottomStatic ? numSize + 10 : 0)  }px`
      }"
    >
      <div
        class="web_template_item_wrap"
        v-for="item of dataArr"
        :key="item.id"
        @click="handleClickNavItem(item)"
        :style="
        {
          backgroundColor: `${item.style.bgType === 'color' ? item.style.bgColor : ''}`,
          backgroundImage: `url(${item.style.bgType === 'image' ? encodeURI(item.style.bgImg) : ''})`,
        }"
      >
        <div
          class="web_template_item_icon"
          :class="item.icon.name"
          :style="`color: ${item.icon.color}`"
          v-show="item.icon.show"
        ></div>
        <div
          class="web_template_item_text"
          :style="`color: ${item.text.color}`"
          v-show="item.text.show"
        >{{item.text.name}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { Lazyload } from 'vant'

Vue.use(Lazyload)
import { ObjectDeepClone, SimpleQicukSort } from '@a/js/utils'
export default {
  props: {
    options: {
      type: Object,
      default: () => { }
    },
    isBottomBtn: {
      type: Boolean,
      default: false
    },
    isBottomStatic: {
      type: Boolean,
      default: false
    },
    numSize: {
      type: Number,
      default: 0
    }
  },
  name: 'WebTemplate3',
  data() {
    return {};
  },

  components: {},

  computed: {
    dataArr() {
      if (this.options.options.list.length > 0) {
        return SimpleQicukSort(ObjectDeepClone(this.options.options.list))
      } else {
        return []
      }

    }
  },

  methods: {
    // 点击跳转
    handleClickNavItem(item) {
      if (item.url.length > 0) {
        window.location.href = item.url
      } else {
        this.$notify({
          type: 'warning',
          message: '敬请期待',
        })
      }
    },
  },

  mounted() {

  },
}
</script>
<style lang='less' scoped>
.web_template_wrap {
  position: relative;
  margin-top: -1px;
  .web_template_bgimg {
    font-size: 0;
    img {
      width: 100%;
    }
  }
  .web_template_content {
    padding: 15px;
    position: absolute;
    z-index: 98;
    top: 0;
    left: 0;
    right: 0;
    .web_template_item_wrap {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-around;
      align-items: center;
      align-content: space-around;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
      height: 100px;
      padding: 10px;
      box-sizing: border-box;
      margin-bottom: 15px;
      &:last-child {
        margin-bottom: 0;
      }
      .web_template_item_icon {
        text-align: center;
        font-size: 40px;
        width: 70px;
      }
      .web_template_item_text {
        flex: 1;
        padding: 0 5px;
        text-align: left;
        font-size: 16px;
        // font-weight: bold;
        letter-spacing: 1px;
      }
    }
  }
}
</style>